const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  admin: state => state.user.admin,
  nameid: state => state.user.nameid,
  roles: state => state.user.roles,
  user_enterprises: state => state.enterprise.enterprises,
  currentEnterprise: state => state.enterprise.current,
  pay: state => state.user.pay
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js